import { Components, radioClasses, Theme } from "@mui/material";

export const MuiRadio: Components<Omit<Theme, "MuiRadio">>["MuiRadio"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      color: palette.common.black,

      [`&.${radioClasses.checked}`]: {
        color: palette.common.black,
      },

      [`&.${radioClasses.disabled}`]: {
        color: palette.grey[400],
      },
    }),
  },
};
